export default "__VITE_ASSET__Gob_oEne__"